import { assert } from '@ember/debug';
import Component from '@glimmer/component';
import UiButtonLoadingIndicatorComponent from './button/loading-indicator';

enum UiButtonAppearance {
  Filled = 'filled',
  Text = 'text',
}

enum UiButtonColor {
  Primary = 'primary',
  Secondary = 'secondary',
  Standard = 'standard',
  Destructive = 'destructive',
}

enum UiButtonSize {
  Small = 'small',
  Normal = 'normal',
  Large = 'large',
}

interface UiButtonSignature {
  Element: HTMLButtonElement;
  Args: {
    Named: {
      appearance?: `${UiButtonAppearance}`;
      color?: `${UiButtonColor}`;
      size?: `${UiButtonSize}`;
    };
  };
  Blocks: {
    default: [typeof UiButtonLoadingIndicatorComponent];
  };
}

export default class UiButton extends Component<UiButtonSignature> {
  get appearance() {
    assert(
      `You tried to pass invalid Ui::Button appearance. "${this.args.appearance}" appearance is not supported.`,
      this.args.appearance
        ? Object.values(UiButtonAppearance).includes(
            this.args.appearance as UiButtonAppearance
          )
        : true
    );

    return this.args.appearance ?? UiButtonAppearance.Filled;
  }

  get color() {
    assert(
      `You tried to pass invalid Ui::Button color. "${this.args.color}" color is not supported.`,
      this.args.color
        ? Object.values(UiButtonColor).includes(
            this.args.color as UiButtonColor
          )
        : true
    );

    return this.args.color ?? UiButtonColor.Primary;
  }

  get size() {
    assert(
      `You tried to pass invalid Ui::Button size. "${this.args.size}" size is not supported.`,
      this.args.size
        ? Object.values(UiButtonSize).includes(this.args.size as UiButtonSize)
        : true
    );

    return this.args.size ?? UiButtonSize.Normal;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Ui::Button': typeof UiButton;
    'ui/button': typeof UiButton;
  }
}
